<template>
  <tr :class="line.reconciliation ? 'green lighten-5' : ''">
    <td>
      {{ line.journal_entry_data.posting_date | shortDate }}
      <span v-if='line.is_expense'> -- {{ line.expense.purchased_at }}</span>
      <v-tooltip right v-if='line.is_deposit && line.deposit.is_credit_card'>
        <template v-slot:activator='{ on }'>
          <v-icon
            :color='$store.state.icons.dataBox.creditCards.iconColor'
            class='ml-4'
            v-on='on'
          >
            {{ $store.state.icons.dataBox.creditCards.icon }}
          </v-icon>
        </template>
        <span>
          Credit card batch
        </span>
      </v-tooltip>
    </td>
    <td class='text-left'>
      {{ line.description }}
      <small class='ml-5'><a @click='viewJE' class='info--text'>View JE</a></small>
      <v-chip
        xSmall
        outlined
        color='warning'
        class='ml-3 px-1'
        v-if='line.journal_entry_data.reversing_entry'
      >Reversing</v-chip>

      <je-dialog
        :showDialog='showJE'
        :journalEntry='line.journal_entry_data'
        :lines='jeLines'
        :highlightAccount='line.account'
        @close='showJE = false'
      ></je-dialog>
    </td>
    <td align='right'>{{ getAmountDisplay(line.debit) }}</td>
    <td align='right'>{{ getAmountDisplay(line.credit) }}</td>
    <td class='text-center'>
      <wc-checkbox
        :disabled='rec.is_locked'
        :status='line.reconciliation !== null'
        :isLoading='isLoading'
        @toggle='toggleInclusion'
      ></wc-checkbox>
    </td>
  </tr>

</template>

<script>
import WCCheckbox from '@/components/forms/WCCheckbox';
import JournalEntryDialog from '@/modules/management/components/financial_reports/JournalEntryDialog';
import accountingAPI from '@/api/accounting';
import _ from 'lodash';

export default {
  name: 'rec-line',
  props: {
    rec: {
      required: true
    },
    line: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    lineCopy: {},
    jeLines: [],
    showJE: false
  }),
  methods: {
    async toggleInclusion () {
      if (this.rec.is_locked === false) {
        this.isLoading = true
        this.lineCopy = _.cloneDeep(this.line)

        // Update the various reconciliation values to either null, or the rec.id
        // Have to determine if the line is a deposit of an expense, and set fields accordingly
        if (this.lineCopy.reconciliation) {
          // If it's currently reconciled, then we undo that, setting it to null
          this.lineCopy.reconciliation = null
        } else {
          this.lineCopy.reconciliation = this.rec.id
        }

        // Now update the line
        this.lineCopy = await accountingAPI.updateJournalEntryLineItem(this.lineCopy.id, this.lineCopy);

        // Send the updated line back up to the reconciliation
        this.$emit('updateLine', this.lineCopy)
        this.isLoading = false
      }
    },
    async viewJE () {
      let tmp = await accountingAPI.getJournalEntryLines(this.line.journal_entry_data.id);
      this.jeLines = tmp
      this.showJE = true
    },
    getAmountDisplay (amt) {
      return amt ? this.$options.filters.decAccounting(amt) : '-'
    }
  },
  components: {
    'wc-checkbox': WCCheckbox,
    'je-dialog': JournalEntryDialog
  }
}
</script>
